(ns ycweb.app.website.dlp.widgets.newarrivals
  (:require
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.app.website.cards :as cards]
   [ycweb.components.common :as cmn]
   [ycweb.components.headings :as headings]
   [ycweb.util.core :as u]))

(rum/defc card-list-view < rum/reactive [app-atom products]
  [:div.flex-grid-group
   (map
     (fn [product]
       [:div
        {:class
         (u/bem :flex-grid-block [:t-full])}
        (cards/product-card-large app-atom product)])
     products)])

(rum/defc custom-lead-in < rum/reactive
  [{:new-arrivals/keys
    [banner-background-colour columns more-url title
     image-alt picture-public-id custom-viewmore-link]}]
  [:div
   {:class
    (u/bem :flex-grid-block
      (if (= columns 6)
        [:small :t-1-2 :ml-1-3 :l-1-6]
        [:t-1-2 :ml-1-4]))}
   [:a.card.ttt-card.flex-grid-content
    {:class
     (if (u/presence banner-background-colour)
       (str "u-bg-" (:banner-background-colour/colour-name banner-background-colour))
       "u-bg-oil")
     :href
     (if (u/presence custom-viewmore-link)
       custom-viewmore-link
       more-url)}
    [:article.ttt-card__content
     [:div.ttt-card__logotype
      [:img.yc-simple-image.yc-simple-image--full
       {:src (u/cloudinary picture-public-id {:urlonly true :original true})
        :image_alt
        (cond
          (u/presence image-alt)
          image-alt

          (u/presence title)
          (str/strip-tags title)

          :else
          "Shop these products")}]]]]])

(rum/defc card-grid-view < rum/reactive
  [app-atom
   {:new-arrivals/keys
    [products columns show-viewmore-link? more-url picture-public-id
     custom-viewmore-text custom-viewmore-link] :as properties}]

  (let [six-cols? (= columns 6)
        display-products
        (if (u/presence picture-public-id)
          (drop-last products)
          products)]
    [:div
     {:class (u/bem :flex-grid-group [:align-left (when six-cols? :small)])}
     (when (u/presence picture-public-id)
       (custom-lead-in properties))

     (map
       (fn [product]
         [:div
          {:class (u/bem :flex-grid-block [:t-1-2 :ml-1-3 (if six-cols? [:l-1-6 :small] :l-1-4)])}
          (cards/product-card-default app-atom product {:small? true})])
       display-products)

     (when show-viewmore-link?
       [:div
        {:class (u/bem :flex-grid-block [:t-1-2 :ml-1-3 (if six-cols? [:l-1-6 :small] :l-1-4)])}
        (cards/more-card
          {:url (if (u/presence custom-viewmore-link) custom-viewmore-link more-url)
           :text custom-viewmore-text})])]))

(rum/defc new-arrivals < rum/reactive [app-atom _ {:keys [properties]}]
  (let [{:new-arrivals/keys
         [show-content? on-page-link-id title heading-type
          products card-view use-date-range? has-line?
          spacer spacer-size]} properties
        navigation (cmn/curact app-atom [:web.dynamic :navigation])

        underline (when has-line? "-underline")]

    (when
     (and
       show-content?
       (not-empty products))
      [:<>
       [:div.yc-section
        {:id (when (u/presence on-page-link-id) on-page-link-id)}
        (when (u/presence title)
          (headings/heading title
            {:type (keyword (str "h" heading-type))
             :size :default
             :dangerouslySetInnerHTML? true}))

        (when-not (empty? products)
          (cond
            (= card-view "list")
            (card-list-view app-atom products)

            :else
            (card-grid-view app-atom properties)))

        (when (and use-date-range? (u/presence spacer))
          [:div
           {:class
            (u/bem :dlp-spacer
              [(if (= spacer-size "medium")
                 (str "medium" underline)
                 (str "standard" underline))])}])]])))
